<template>
  <div>
    <div class="HeroImage__content">
      <div>
        <h1 class="HeroImage__content__heading">{{ $t("homePageHeading")}}</h1>
        <h2 class="HeroImage__content__subheading">{{ $t("selectLocationMsg")}}</h2>

        <div class="Selection">
          <router-link class="Selection__item" to="/view-photos/to"><span v-html="$t('asJP')"></span></router-link>
          <router-link class="Selection__item" to="/view-photos/si"><span v-html="$t('asCN')"></span></router-link>
          <router-link class="Selection__item" to="/view-photos/si"><span v-html="$t('asMO')"></span></router-link>
          <router-link class="Selection__item" to="/view-photos/si"><span v-html="$t('asHK')"></span></router-link>
          <router-link class="Selection__item" to="/view-photos/si"><span v-html="$t('asSG')"></span></router-link>
          <router-link class="Selection__item" to="/view-photos/to"><span v-html="$t('asKR')"></span></router-link>
          <router-link class="Selection__item" to="/view-photos/si"><span v-html="$t('asTH')"></span></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  mounted: function () {
    document.body.className = 'homePage'
  },
  beforeDestroy: function() {
    document.body.className = '';
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import './../styles/_variables';

body.homePage {
  background-image: url('./../assets/bg/fun-with-colours.jpg');

  .HeroImage__content__heading {
      font-weight: bold;

      @media (max-width: em(423)) {
        font-size: 2em;
      }

      @media (min-width: em(780)) {
        margin-top: 2em;
      }

    }
    .Selection__item {
      text-transform: uppercase;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/RegionSubselect.vue